import { useLocale } from '../context';

function fmt(n) {
  return Number(n || 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 });
}

export function resolveWagerFromSources(...sources) {
  for (const s of sources) {
    if (!s) continue;
    if (s.wager && Number(s.wager.required) > 0.009) return s.wager;
    const bonusReq = Number(s.bonus_wager_required || 0);
    const bonusProg = Number(s.bonus_wager_progress || 0);
    const bonusBal = Number(s.bonus_balance || s.bonusBalance || 0);
    const depReq = Number(s.deposit_wager_required || 0);
    const depProg = Number(s.deposit_wager_progress || 0);
    if (bonusReq > 0.009 && (bonusBal > 0.009 || bonusProg + 0.009 < bonusReq)) {
      return {
        kind: 'bonus',
        label: s.active_bonus_title || null,
        required: bonusReq,
        progress: Math.min(bonusReq, bonusProg),
        percent: Math.min(100, Math.round((bonusProg / bonusReq) * 1000) / 10),
        remaining: Math.max(0, Math.round((bonusReq - bonusProg) * 100) / 100),
        complete: bonusProg + 0.009 >= bonusReq,
      };
    }
    if (depReq > 0.009 && depProg + 0.009 < depReq) {
      return {
        kind: 'deposit',
        label: null,
        required: depReq,
        progress: Math.min(depReq, depProg),
        percent: Math.min(100, Math.round((depProg / depReq) * 1000) / 10),
        remaining: Math.max(0, Math.round((depReq - depProg) * 100) / 100),
        complete: false,
      };
    }
  }
  return null;
}

export default function WagerStatusBar({
  wager,
  compact = false,
  onClick,
  className = '',
}) {
  const { t, locale } = useLocale();
  if (!wager || !(Number(wager.required) > 0.009) || wager.complete) return null;

  const pct = Math.max(0, Math.min(100, Number(wager.percent) || 0));
  const isEn = locale === 'en';
  const title = wager.kind === 'deposit'
    ? (isEn ? 'Deposit wagering' : (t('account.wager.depositTitle') || 'Yatırım çevrimi'))
    : (wager.label || (isEn ? 'Bonus wagering' : (t('account.wager.bonusTitle') || 'Bonus çevrimi')));
  const caption = isEn
    ? (t('account.wager.progress') || 'Wagering progress')
    : (t('account.wager.progress') || 'Çevrim durumu');

  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={`vb-wager-status${compact ? ' vb-wager-status--compact' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
    >
      <div className="vb-wager-status__head">
        <span className="vb-wager-status__caption">{caption}</span>
        <strong className="vb-wager-status__pct">
          {pct.toLocaleString('tr-TR', { maximumFractionDigits: 1 })}%
        </strong>
      </div>
      <div className="vb-wager-status__title">{title}</div>
      <div className="vb-wager-status__track" aria-hidden="true">
        <div className="vb-wager-status__fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="vb-wager-status__meta">
        <span>{fmt(wager.progress)} / {fmt(wager.required)} TL</span>
        {!compact ? (
          <span>
            {isEn ? 'Left' : 'Kalan'}: {fmt(wager.remaining)} TL
          </span>
        ) : null}
      </div>
    </Tag>
  );
}
